<!-- ========== Left Sidebar Start ========== -->
<div *ngIf="showMobileMenu" class="left-side-menu left-side-dark">
  <div class="h-100 pv-1" data-simplebar>
    <!--- Sidemenu -->
    <div class="logo-box">
      <a class="logo">
        <span class="logo-lg">
          <img *ngIf="result" src="{{img}}" width="90" style="margin-left: 60px" (click)="redirectHome()" />
        </span>
      </a>
    </div>
    <nav id="sidebar-menu">
      <ul id="side-menu">
        <li *ngFor="let item of menu">
          <ng-container *ngIf="viewComponent(item) && viewToggle(item)">
            <a
              (click)="openCloseMenu(item, true)"
              *ngIf="!item.url_externo"
              [matTooltip]="item.tooltip"
              [ngClass]="{'background-orange': item.name === selected }"
              [routerLink]="item.url"
              class="side-nav-link-ref"
              matTooltipClass="tooltip-menu"
              matTooltipPosition="right"
            >
              <span class="d-flex align-items-center">
                <i *ngIf="!item.img" class="fg" [ngClass]="item.icon"></i>
                <i
                  *ngIf="item.img && (roles === 'ADMINISTRADOR' || roles === 'PARTNER' || item.img && roles === 'CORBAN')"
                  class="mr-1 icon"
                  alt="{{item?.alt}}"
                  class="{{item.icon}}"
                ></i>
                <i
                  *ngIf="item.img && item.icon_business_banker === false && roles === 'BUSINESS BANKER'"
                  class="mr-1 icon"
                  alt="{{item?.alt}}"
                  class="{{item.icon}}"
                ></i>
                <i
                  *ngIf="item.img && item.icon_business_banker !== false && roles === 'BUSINESS BANKER'"
                  class="mr-1 icon"
                  alt="{{item?.alt}}"
                  class="{{item.icon}}"
                ></i>
                <span [innerHtml]="item.name"></span>
                <span *ngIf="item.label" class="label-em-breve">Em Breve</span>
                <span
                  *ngIf="item.childs"
                  [ngClass]="{'menu-arrow-open': item.show}"
                  class="mdi mdi-apple-keyboard-control menu-arrow"
                ></span>
              </span>
            </a>

            <a
              *ngIf="item.url_externo"
              [matTooltip]="item.tooltip"
              class="side-nav-link-ref anchor-link"
              href="{{item.url_externo}}"
              matTooltipClass="tooltip-menu"
              matTooltipPosition="right"
              target="_blank"
            >
              <span class="d-flex align-items-center">
                <i *ngIf="!item.img" [ngClass]="item.icon"></i>
                <i
                  *ngIf="item.img && (roles === 'ADMINISTRADOR' || roles === 'PARTNER' || item.img && roles === 'CORBAN')"
                  class="mr-1 icon"
                  alt="{{item?.alt}}"
                  class="{{item.icon}}"
                ></i>
                <i
                  *ngIf="item.img && item.icon_business_banker === false && roles === 'BUSINESS BANKER'"
                  class="mr-1 icon"
                  alt="{{item?.alt}}"
                  class="{{item.icon}}"
                ></i>
                <i
                  *ngIf="item.img && item.icon_business_banker !== false && roles === 'BUSINESS BANKER'"
                  class="mr-1 icon"
                  alt="{{item?.alt}}"
                  class="{{item.icon}}"
                ></i>
                <span>{{item.name}}</span>
                <span *ngIf="item.label" class="label-em-breve">{{item.label}}</span>
                <span
                  *ngIf="item.childs"
                  [ngClass]="{'menu-arrow-open': item.show}"
                  class="mdi mdi-apple-keyboard-control menu-arrow"
                ></span>
              </span>
            </a>

            <div *ngIf="item.childs" [ngClass]="{'show-child-menu': item.show, 'hidde-child-menu': !item.show}">
              <ul class="nav-second-level">
                <li *ngFor="let child of item.childs">
                  <div *ngIf="(!child.permission) || (child.permission && child.permission.indexOf(roles) !== -1)">
                    <div *ngIf="child.name === 'Novo Cliente' && (roles === 'ADMINISTRADOR'); else showThis">
                      <ng-template #showThis>
                        <a
                          *ngIf="!child.url_externo"
                          [queryParams]="{ type: child.type }"
                          [routerLink]="child.url"
                          class="d-flex align-items-center"
                        >
                          <i *ngIf="!child.img" [ngClass]="child.icon"></i>
                          <img
                            *ngIf="child.img && roles !== 'BUSINESS BANKER'"
                            class="mr-1"
                            height="35"
                            src="../../../assets/menu-items/{{child.icon}}"
                            width="35"
                            alt="{{item?.alt}}"
                          />
                          <img
                            *ngIf="child.img && roles === 'BUSINESS BANKER'"
                            class="mr-1"
                            height="35"
                            src="../../../assets/menu-items/{{child.icon_business_banker}}"
                            width="35"
                            alt="{{item?.alt}}"
                          />
                          <strong>{{child.name}}</strong>
                          <span *ngIf="child.label" class="label-em-breve">{{child.label}}</span>
                          <span
                            *ngIf="child.childs"
                            [ngClass]="{'menu-arrow-open': item.show}"
                            class="mdi mdi-apple-keyboard-control menu-arrow"
                          ></span>
                        </a>
                        <a
                          *ngIf="child.url_externo"
                          class="d-flex align-items-center"
                          href="{{child.url_externo}}"
                          target="_blank"
                        >
                          <i *ngIf="!child.img" [ngClass]="child.icon"></i>
                          <img
                            *ngIf="child.img && (roles === 'ADMINISTRADOR' || roles === 'PARTNER' || roles === 'CORBAN')"
                            class="mr-1"
                            height="35"
                            src="../../../assets/menu-items/{{child.icon}}"
                            width="35"
                            alt="{{item?.alt}}"
                          />
                          <img
                            *ngIf="child.img && child.icon_business_banker === false && roles === 'BUSINESS BANKER'"
                            class="mr-1"
                            height="35"
                            src="../../../assets/menu-items/{{child.icon}}"
                            width="35"
                            alt="{{item?.alt}}"
                          />
                          <img
                            *ngIf="child.img && child.icon_business_banker !== false && roles === 'BUSINESS BANKER'"
                            class="mr-1"
                            height="35"
                            src="../../../assets/menu-items/{{child.icon_business_banker}}"
                            width="25"
                            alt="{{item?.alt}}"
                          />
                          <strong>{{child.name}}</strong>
                          <span *ngIf="child.label" class="label-em-breve">{{child.label}}</span>
                          <span
                            *ngIf="child.childs"
                            [ngClass]="{'menu-arrow-open': item.show}"
                            class="mdi mdi-apple-keyboard-control menu-arrow"
                          ></span>
                        </a>
                      </ng-template>
                    </div>

                    <ng-template #showThis>
                      <a
                        *ngIf="!child.url_externo"
                        [queryParams]="{ type: child.type }"
                        [routerLink]="child.url"
                        class="d-flex align-items-center"
                      >
                        <i *ngIf="!child.img" [ngClass]="child.icon"></i>
                        <img
                          *ngIf="child.img && roles !== 'BUSINESS BANKER'"
                          class="ml-2"
                          height="auto"
                          src="../../../assets/menu-items/{{child.icon}}"
                          width="35"
                          alt="{{item?.alt}}"
                        />
                        <img
                          *ngIf="child.img && roles === 'BUSINESS BANKER'"
                          class="ml-2"
                          height="auto"
                          src="../../../assets/menu-items/{{child.icon_business_banker}}"
                          width="35"
                          alt="{{item?.alt}}"
                        />

                        <div *ngIf="child.name === 'Solicitar'" class="svg ml-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20">
                            <path
                              id="Caminho_2191"
                              data-name="Caminho 2191"
                              d="M10.939,0A.536.536,0,0,1,11,.012h.2a.743.743,0,0,1,.539.233h0l5.05,5.312A.761.761,0,0,1,17,6.08h0v9.251A4.631,4.631,0,0,1,12.534,20H4.57A4.571,4.571,0,0,1,0,15.332H0V12.809a.752.752,0,0,1,.748-.755.752.752,0,0,1,.748.755h0v2.523A3.049,3.049,0,0,0,4.57,18.49h7.964A3.11,3.11,0,0,0,15.5,15.332h0V6.383L11.687,2.368V3.685A1.831,1.831,0,0,0,13.5,5.522a.755.755,0,0,1,0,1.51h0a3.337,3.337,0,0,1-3.309-3.348h0V1.522H4.57a3.078,3.078,0,0,0-3.075,3h0V8.7a.752.752,0,0,1-.748.755A.752.752,0,0,1,0,8.7H0V4.522A4.6,4.6,0,0,1,4.57.012h6.312C10.9.01,10.92,0,10.939,0ZM8.115,6.737a.745.745,0,0,1,.529.22h0l2.83,2.87a.762.762,0,0,1,0,1.068.745.745,0,0,1-1.058,0h0L8.863,9.319v4.79a.748.748,0,1,1-1.5,0h0V9.319L5.816,10.895a.743.743,0,0,1-1.058,0,.762.762,0,0,1,0-1.068h0l2.83-2.87h0l.087-.075A.744.744,0,0,1,8.115,6.737Z"
                              fill="#eb6625"
                            />
                          </svg>
                        </div>

                        <div *ngIf="child.name === 'Compartilhados'" class="svg ml-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19.499"
                            height="19.5"
                            viewBox="0 0 19.499 19.5"
                          >
                            <path
                              id="Fill-1"
                              d="M8.8,11.818l3.657,5.933a.5.5,0,0,0,.511.243.508.508,0,0,0,.432-.371L17.978,2.178a.522.522,0,0,0-.133-.525.512.512,0,0,0-.512-.132L1.877,6.047A.529.529,0,0,0,1.747,7l6,3.753L13.05,5.4a.75.75,0,0,1,1.067,1.055Zm4.09,7.682a2,2,0,0,1-1.71-.962L7.308,12.247.952,8.272a2.028,2.028,0,0,1,.5-3.664L16.911.082a2.022,2.022,0,0,1,2.5,2.522L14.842,18.048a2,2,0,0,1-1.67,1.433,2.173,2.173,0,0,1-.277.019Z"
                              transform="translate(0 0)"
                              fill="#eb6625"
                              fill-rule="evenodd"
                            />
                          </svg>
                        </div>

                        <div *ngIf="child.name === 'Saiba Mais'" class="svg ml-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20">
                            <path
                              id="Caminho_2192"
                              data-name="Caminho 2192"
                              d="M9.752,0a.457.457,0,0,1,.455.46h0V3.68a3.349,3.349,0,0,0,3.307,3.34c.752,0,1.346.01,1.8.01.307,0,.812-.01,1.238-.01A.446.446,0,0,1,17,7.47h0v8.04A4.47,4.47,0,0,1,12.545,20H4.673A4.7,4.7,0,0,1,0,15.29H0V4.51A4.5,4.5,0,0,1,4.465,0H9.752ZM8.317,7.77a.743.743,0,0,0-.743.74h0v1.73h-1.7a.745.745,0,0,0,0,1.49h1.7v1.73a.743.743,0,0,0,.743.74.735.735,0,0,0,.733-.74h0V11.73h1.713a.745.745,0,0,0,0-1.49H9.05V8.51A.735.735,0,0,0,8.317,7.77ZM11.65.906a.473.473,0,0,1,.814-.334L16.45,4.759a.477.477,0,0,1-.34.807c-.814,0-1.773,0-2.463-.007a2.017,2.017,0,0,1-2-2.017h0Z"
                              fill="#eb6625"
                            />
                          </svg>
                        </div>

                        <div class="ml-3">
                          <strong>{{child.name}}</strong>
                        </div>
                        <span *ngIf="child.label" class="label-em-breve">{{child.label}}</span>
                        <span
                          *ngIf="child.childs"
                          [ngClass]="{'menu-arrow-open': item.show}"
                          class="mdi mdi-apple-keyboard-control menu-arrow"
                        ></span>
                      </a>
                      <a
                        *ngIf="child.url_externo"
                        class="d-flex align-items-center"
                        href="{{child.url_externo}}"
                        target="_blank"
                      >
                        <i *ngIf="!child.img" [ngClass]="child.icon"></i>
                        <img
                          *ngIf="child.img && (roles === 'ADMINISTRADOR' || roles === 'PARTNER' || roles === 'CORBAN')"
                          class="mr-1"
                          height="35"
                          src="../../../assets/menu-items/{{child.icon}}"
                          width="35"
                          alt="{{item?.alt}}"
                        />
                        <img
                          *ngIf="child.img && child.icon_business_banker === false && roles === 'BUSINESS BANKER'"
                          class="mr-1"
                          height="35"
                          src="../../../assets/menu-items/{{child.icon}}"
                          width="35"
                          alt="{{item?.alt}}"
                        />
                        <img
                          *ngIf="child.img && child.icon_business_banker !== false && roles === 'BUSINESS BANKER'"
                          class="mr-1"
                          height="35"
                          src="../../../assets/menu-items/{{child.icon_business_banker}}"
                          width="25"
                          alt="{{item?.alt}}"
                        />
                        <strong>{{child.name}}</strong>
                        <span *ngIf="child.label" class="label-em-breve">{{child.label}}</span>
                        <span
                          *ngIf="child.childs"
                          [ngClass]="{'menu-arrow-open': item.show}"
                          class="mdi mdi-apple-keyboard-control menu-arrow"
                        ></span>
                      </a>
                    </ng-template>

                    <div
                      *ngIf="child.childs"
                      [ngClass]="{'show-child-menu': item.show, 'hidde-child-menu': !item.show}"
                    >
                      <ul class="nav-second-level">
                        <li *ngFor="let child2 of child.childs">
                          <a *ngIf="!child2.url_externo" [routerLink]="child2.url" class="d-flex align-items-center">
                            <i *ngIf="!child2.img" [ngClass]="child.icon"></i>
                            <img
                              *ngIf="child2.img"
                              class="mr-1"
                              height="35"
                              src="../../../assets/menu-items/{{child2.icon}}"
                              width="35"
                              alt="{{item?.alt}}"
                            />
                            <strong>{{child2.name}}</strong>
                            <span *ngIf="child2.label" class="label-em-breve">{{child2.label}}</span>
                            <span
                              *ngIf="child2.childs"
                              [ngClass]="{'menu-arrow-open': item.show}"
                              class="mdi mdi-apple-keyboard-control menu-arrow"
                            ></span>
                          </a>
                          <a
                            *ngIf="child2.url_externo"
                            class="d-flex align-items-center"
                            href="{{child2.url_externo}}"
                            target="_blank"
                          >
                            <i *ngIf="!child2.img" [ngClass]="child2.icon"></i>
                            <img
                              *ngIf="child2.img"
                              class="mr-1"
                              height="35"
                              src="../../../assets/menu-items/{{child2.icon}}"
                              width="35"
                              alt="{{item?.alt}}"
                            />
                            <strong>{{child2.name}}</strong>
                            <span *ngIf="child2.label" class="label-em-breve">{{child2.label}}</span>
                            <span
                              *ngIf="child2.childs"
                              [ngClass]="{'menu-arrow-open': item.show}"
                              class="mdi mdi-apple-keyboard-control menu-arrow"
                            ></span>
                          </a>

                          <div
                            *ngIf="child2.childs"
                            [ngClass]="{'show-child-menu': item.show, 'hidde-child-menu': !item.show}"
                          >
                            <ul class="nav-second-level">
                              <li *ngFor="let child3 of child2.childs">
                                <a *ngIf="!child3.url_externo" [routerLink]="child3.url">
                                  <i *ngIf="!child3.img" [ngClass]="child.icon"></i>
                                  <img
                                    *ngIf="child3.img"
                                    class="mr-1"
                                    height="35"
                                    src="../../../assets/menu-items/{{child3.icon}}"
                                    width="35"
                                    alt="{{item?.alt}}"
                                  />
                                  <strong>{{child3.name}}</strong>
                                  <span *ngIf="child3.label" class="label-em-breve">{{child3.label}}</span>
                                  <span
                                    *ngIf="child3.childs"
                                    [ngClass]="{'menu-arrow-open': item.show}"
                                    class="mdi mdi-apple-keyboard-control menu-arrow"
                                  ></span>
                                </a>
                                <a
                                  *ngIf="child3.url_externo"
                                  class="d-flex align-items-center"
                                  href="{{child3.url_externo}}"
                                  target="_blank"
                                >
                                  <i *ngIf="!child3.img" [ngClass]="child.icon"></i>
                                  <img
                                    *ngIf="child3.img"
                                    class="mr-1"
                                    height="35"
                                    src="../../../assets/menu-items/{{child3.icon}}"
                                    width="35"
                                    alt="{{item?.alt}}"
                                  />
                                  <strong>{{child3.name}}</strong>
                                  <span *ngIf="child3.label" class="label-em-breve">{{child3.label}}</span>
                                  <span
                                    *ngIf="child3.childs"
                                    [ngClass]="{'menu-arrow-open': item.show}"
                                    class="mdi mdi-apple-keyboard-control menu-arrow"
                                  ></span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </ng-container>
        </li>
      </ul>
    </nav>
    <!-- End Sidebar -->
    <div class="clearfix"></div>
  </div>
  <!-- Sidebar -left -->
</div>
